export default __webpack_public_path__ + "e904be91a297f934b5328b29e2f34fa3.svg";